import { render, staticRenderFns } from "./TabelaEspera.vue?vue&type=template&id=644ec1e4"
import script from "./TabelaEspera.vue?vue&type=script&lang=js"
export * from "./TabelaEspera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports